module.exports = __webpack_public_path__ + "static/media/Welcome-1.cc3136b3.jpg";